module.exports = "pegasus_template/assets/blocks/social-1-theme5.png";